var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapturingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3095 11.0714V6.634C27.3095 5.85251 26.9996 5.1029 26.4479 4.54948C25.8961 3.99605 25.1474 3.68397 24.366 3.68162L19.9285 3.66833M27.3095 19.9286V24.3571C27.3095 25.1402 26.9984 25.8911 26.4447 26.4448C25.8911 26.9985 25.1401 27.3095 24.3571 27.3095H19.9285M11.0714 3.66833L6.63395 3.6831C5.85247 3.68544 5.10379 3.99753 4.55203 4.55095C4.00026 5.10438 3.69043 5.85399 3.69043 6.63548V11.0714M11.0714 27.3095H6.64281C5.85979 27.3095 5.10884 26.9985 4.55516 26.4448C4.00148 25.8911 3.69043 25.1402 3.69043 24.3571V19.9286",
    stroke: "#FB1515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapturingIcon);
export default __webpack_public_path__ + "static/media/CapturingIcon.b1a7d44c099b82dead74ec511a4e7236.svg";
export { ForwardRef as ReactComponent };